import React from 'react';
import NoInfo from '../helpers/NoInfo';
import ErrorLog from './ErrorLog';
import { AppRemixIcon } from '@/layout/AppComponents';
import * as Sentry from '@sentry/react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.global = props.global;
    this.auth = props.auth;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    Sentry.captureException(error, {
      user: {
        id: this.auth?.user?.id,
        email: this.auth?.user?.email,
        username: this.auth?.user?.user,
      },
      extra: errorInfo,
      tags: {
        client: this.auth?.user?.client?.name,
      },
    });

    ErrorLog(error, errorInfo);
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (process.env.NODE_ENV === 'development') {
        return (
          <div style={{ padding: 20 }}>
            <h2>💥 Error capturado por ErrorBoundary</h2>
            <pre style={{ color: 'red', whiteSpace: 'pre-wrap' }}>
              {this.state.error?.toString()}
            </pre>
            <pre style={{ color: '#555', whiteSpace: 'pre-wrap' }}>
              {this.state.errorInfo?.componentStack}
            </pre>
          </div>
        );
      }
      return (
        <NoInfo
          icon={<AppRemixIcon icon="information" size={34} color="#ccc" />}
          text="Ha habido un error... Si continua ocurriendo, contacte con worldlex"
        />
      );
    }
    return this.props.children;
  }
}
